export const EngageAITypeDecorator = {
  url() {
    return `signup-hubspot/engage-ai`;
  },
  query() {
    return {};
  }
};